export const PAGINATION = {
  ITEMS_PER_PAGE: 8,
};
